export const appsStoreLinks = {
  android: 'https://app.adjust.com/186jcc35',
  ios: 'https://app.adjust.com/18wci921',
  unique: 'https://app.adjust.com/1agb4obq_1aljnt8i',
  eqi: {
    trader: {
      android:
        'https://play.google.com/store/apps/details?id=com.btg.pactual.homebroker.mobile.eqi',
      ios: 'https://apps.apple.com/br/app/eqi-trader/id1606793010',
    },
  },
};
